import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../../../typography';
import { getWebUrl } from '../../../../utilities/browser';
const NotificationNotActivated = ({ username }) => (_jsxs(_Fragment, { children: ["Klik op de bevestigingslink in je inbox of laat", ' ', _jsx(Typography, { variant: "link-text", href: `https://${getWebUrl()}/activatie-sturen#username=${username}`, target: "_parent", children: "deze e-mail opnieuw sturen" })] }));
export default NotificationNotActivated;
